import { TableContainer } from "@mui/material";
import { Table } from "antd";
import React, { useState } from "react";
import ExportToExcel from "~/components/ExportToExcel";

const LocationData = (data) => {
  console.log(data.reportData, "locationFetchData");
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 25,
    },
  });

  const columns = [
    {
      title: "Location Name",
      dataIndex: "Loc_Name",
      key: "Loc_Name",
      width: 100,
    },
    {
      title: "Location Type",
      dataIndex: "Loc_Type",
      key: "Loc_Type",
      width: 100,
    },
    {
      title: "Total Location Area (H.A)",
      dataIndex: "Loc_Total_Area",
      key: "Loc_Total_Area",
      width: 100,
    },
    {
      title: "Type of land",
      dataIndex: "Type_of_land",
      key: "Type_of_land",
      width: 100,
    },
    {
      title: "Total plotting count",
      dataIndex: "Total_Ploting_Count",
      key: "Total_Ploting_Count",
      width: 100,
    },
  ];

  return (
    <>
      <ExportToExcel data={data.reportData} columns={columns} fileName="Location Data.csv" />
      <TableContainer sx={{ boxShadow: "none" }}>
        <Table
          columns={columns}
          dataSource={data.reportData}
          pagination={{
            showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
          }}
        />
      </TableContainer>
    </>
  );
};

export default LocationData;
